module.exports = __webpack_public_path__ + "static/media/rentarover.780c3dc0.svg";